'use strict';

var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var FloatingActionButton = require('../../Inputs/Buttons/FloatingActionButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  actionBarRow: {
    position: 'absolute',
    width: '100%',
    pointerEvents: 'none',
    zIndex: 5
  },
  actionBar: {
    pointerEvents: 'auto',
    position: 'absolute',
    right: 50
  }
};

var TableActionBar = function TableActionBar(_ref) {
  var offset = _ref.offset,
      classes = _ref.classes,
      children = _ref.children;
  return React__default["default"].createElement("div", {
    className: classes.actionBarRow,
    style: {
      top: offset
    }
  }, React__default["default"].createElement(FloatingActionButton, {
    variant: "container",
    className: classes.actionBar,
    component: "div"
  }, children));
};

var TableActionBar$1 = withStyles["default"](styles)(TableActionBar);

module.exports = TableActionBar$1;
